module.exports = __webpack_public_path__ + "img/2024-07-01d_2.13c199d6.jpg";